import React, { Component } from 'react'

class SearchWithAction extends Component {
    render() {
        let className = this.props.className;
        className += " form-horizontal form-search";
        return (
            <div className={className}>
                <div className="form-group row">
                    <div className={this.props.hideAction ? "col-12" : "col-9"}>
                        <input
                            type="text"
                            onChange={(event) => this.props.onChange(event.target.value)}
                            className="form-control" placeholder={this.props.placeholder} />
                    </div>
                    {!this.props.hideAction && (
                      
                        this.props.is_admin && (
                            <div className="col-3">
                            <button
                                onClick={this.props.onActionClick}
                                className="btn btn-info btn-block">{this.props.action}</button>
                        </div>
                        )
                      
                    )}
                </div>
            </div>
        )
    }
}

SearchWithAction.defaultProps = {
    onChange(text) { },
    onActionClick() { },
    action: 'ACTION',
    placeholder: 'Search here...'
}

export default SearchWithAction;


// WEBPACK FOOTER //
// ./src/components/SearchWithAction.js